import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Button, Fade, Grid, IconButton, Modal, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { ExtendedAlert } from './types';

/**
 * Notification Modal
 */
interface NotificationModalProps {
  modalOpened: boolean;
  changeModalState: (s: boolean) => void;
  message: ExtendedAlert | undefined;
}

const NotificationModal: FC<NotificationModalProps> = ({ modalOpened, changeModalState, message }) => {
  const closeModal = () => changeModalState(false);

  const getIcon = () => {
    if (message?.severity === 'error') return <WarningRoundedIcon color='error' sx={{ fontSize: 128 }} />;
    if (message?.severity === 'success') return <CheckCircleRoundedIcon color='success' sx={{ fontSize: 128 }} />;
    return null;
  };

  return (
    <Modal
      open={modalOpened}
      onClose={closeModal}
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Fade in={modalOpened}>
        <Paper
          sx={{ padding: 7, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}
        >
          <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={closeModal}>
            <CloseIcon />
          </IconButton>
          <Typography variant='h1' sx={{ fontSize: 24, fontWeight: 'bold' }}>
            {message?.message}
          </Typography>
          <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 2 }}>{getIcon()}</Grid>
          {message?.description && (
            <Typography variant='body1' sx={{ textAlign: 'center', my: 2, maxWidth: 300, whiteSpace: 'normal' }}>
              {message.description}
            </Typography>
          )}
          <Button onClick={closeModal} sx={{ fontWeight: 'bold' }}>
            {message?.buttonText || 'FECHAR'}
          </Button>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default NotificationModal;
